import React, { useState } from 'react';
import './index.css';
import { Link, Route, Switch, useHistory } from 'react-router-dom';
import { shape } from 'prop-types';
import Loader from '@components/Loader';
import Loadable from 'react-loadable';
import { firebaseAnalytics } from '../firebaseConfig';
import { logEvent } from 'firebase/analytics';

const errorLoading = (err) =>
  console.log('Dynamic home page loading failed', err);

const CreateJiveRoute = Loadable({
  loader: () => import('@routes/CreateJiveBird').catch(errorLoading),
  loading: () => <Loader />, // full page loader here
  delay: 200, // delay in milliseconds, useful for suspense
});

const LaunchPage = () => {
  logEvent(firebaseAnalytics, 'IntroVideo_StartedPlayback');
  const history = useHistory();
  const [toggel, setToggel] = useState(false);

  const handleMute = () => {
    var vide = document.getElementById('vid');
    if (toggel === false) {
      vide.muted = false;
      setToggel(true);
    } else {
      vide.muted = true;
      setToggel(false);
    }
  };

  return (
    <div className="App">
      <header className="App-header">
        <video
          id="vid"
          className="videoScreen"
          controls
          controlsList="nodownload nofullscreen noremoteplayback"
          // autoPlay
          // muted
          onEnded={() => {
            logEvent(firebaseAnalytics, 'IntroVideo_WatchedFull');
            // history.push('/create-jive-bird')
          }}>
          <source
            src="https://jivebirdbucketprod.s3.eu-west-2.amazonaws.com/webapp-assets/JiveBirdvideo.mp4"
            type="video/mp4"
          />
        </video>
        {/* <div className="mt-4">
          <Link to="/create-jive-bird">
            {' '}
            <button className="btn homebutn">SKIP</button>{' '}
          </Link>
        </div> */}
      </header>
    </div>
  );
};

const Routes = () => {
  return (
    // <Switch>
    //   {pathname === '/' ? (
    //     <Route path="/" component={LaunchPage} />
    //   ) : (
    //     <Switch>
    //       <Route
    //         key="createjive"
    //         exact
    //         path="/create-jive-bird"
    //         component={CreateJiveRoute}
    //       />
    //     </Switch>

    //   )}
    // </Switch>
    <CreateJiveRoute />
  );
};

Routes.propTypes = {
  history: shape({}).isRequired,
  location: shape({}).isRequired,
  match: shape({}).isRequired,
};

const RootRoutes = () => <Route component={Routes} />;

export default RootRoutes;
